exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.international-icon[data-v-f142be86] {\n  font-size: 20px;\n  cursor: pointer;\n  vertical-align: -5px!important;\n}\n", ""]);

// exports
